import { render, staticRenderFns } from "./textoFaltante.vue?vue&type=template&id=7e00365e"
import script from "./textoFaltante.vue?vue&type=script&lang=js"
export * from "./textoFaltante.vue?vue&type=script&lang=js"
import style0 from "./textoFaltante.vue?vue&type=style&index=0&id=7e00365e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports